import { Club, ClubType } from '@fable/types'
import { useActions } from 'hooks'
import { AppDeepLinkModal } from 'components/app_deep_link_modal'

export const ClubJoinedModal = ({
  club,
  clubType,
}: {
  club?: Club
  clubType?: ClubType
}) => {
  const { sendClubInviteSms } = useActions()

  return (
    <AppDeepLinkModal
      link={club?.deep_link_url as string}
      onSendSMS={(phoneNumber) => sendClubInviteSms(phoneNumber, club)}
      eventMetadata={{ clubType: clubType }}
      description="Download the app to join this club!"
      hideSMS
    />
  )
}
